export default "__VITE_ASSET__BjfdJstn__"